// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const platformSharedLogin = {
  summary: "平台管理类工作台统一通过统一身份接管当前会话，再进入对应控制面。",
  bootstrapTitle: "正在检测统一身份登录状态",
  bootstrapDescription: "如果你已经在门户完成登录，这里会直接识别当前身份。",
  noSessionTitle: "未检测到可用的统一身份会话",
  noSessionDescription: "请先在门户完成登录，再返回此页面继续进入当前工作台。",
  portalAction: "前往门户登录",
  enterAction: "以当前身份进入",
  switchIdentityAction: "切换身份",
  redetectAction: "重新检测统一身份会话",
} as const;
